<template>
  <a-modal
    title="订单支付"
    :width="600"
    :dialog-style="{ top: '20px' }"
    :maskClosable="false"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <p style="line-height:1.3em;color: red;">暂不支持在线支付</p>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import {randomUUID} from '@/utils/util'
import { getAction } from "@/api/manage";
import {mixinDevice} from '@/utils/mixin.js'
export default {
  name: "EventPay",
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      payInfo: {
      },
      callbackUrl:  ""
    };
  },
  created() {},
  mounted(){
  },
  methods: {
    open(orderInfo){
      console.log(orderInfo);
      this.payInfo = {
        orderNo: orderInfo.orderNo,
        orderPrice: orderInfo.orderPrice / 100
      }
      this.callbackUrl = window.location.href + '#payok-' + this.payInfo.orderNo
      this.visible = true
    },
    handleCancel(){
      this.visible = false
      this.$emit("cancel")
    },
    checkOrder(orderId){
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo="+orderId).then(res=>{
        if(res.success){
          this.$message.success('支付成功');
          this.$emit("payOk")
        }else{
          this.$message.error(res.message);
        }
      })
    },
    pay(type) {
      let that = this
      this.$confirm({
        title: '是否支付成功?',
        content: '请在打开的页面进行付款，付款后，确认付款结果',
        onOk() {
          that.checkOrder(that.payInfo.orderNo)
        },
        okText: "支付成功",
        onCancel() {
          that.checkOrder(that.payInfo.orderNo)
          alert("请联系老师处理")
        },
        cancelText: "支付失败"
      });
    },
    //创建post表单
    createForm(action, params, target) {
      console.log("createForm");
      console.log(action);
      console.log(params);
      //alert(JSON.stringify(params))
      var temp = document.createElement("form"); //创建form标签
      temp.action = action; //这里写URL
      temp.method = "post"; //post方式提交
      temp.target = target
      temp.style.display = "none"; //设置为不可见
      for (var key in params) {
        var element;
        element = document.createElement("input");
        element.setAttribute("type", "hidden");
        element.name = key;
        element.value = params[key];
        temp.appendChild(element);
      }
      document.body.appendChild(temp); //将form标签添加到body标签内
      return temp;
    },
  },
};
</script>

<style>
</style>